// extracted by mini-css-extract-plugin
module.exports = {"guarantees":"styles_guarantees__O53A8"};